import { ArrowRight } from "lucide-react";

const pillars = [
  { label: "Clarity" },
  { label: "Integrity" },
  { label: "Transparency" }
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 border-t border-neutral-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="overline mb-12" data-testid="about-overline">About Rob</p>

        <div className="grid md:grid-cols-12 gap-12 md:gap-16 items-start">
          {/* Photo */}
          <div className="md:col-span-5" data-testid="about-photo-wrap">
            <div className="relative">
              <div className="absolute -inset-3 border border-[#36C281]/25 translate-x-3 translate-y-3" />
              <img
                src="https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/40td1wf5_ROBBIE_POWER_FS_02.jpg"
                alt="Rob Power — Buyers Agent"
                loading="lazy"
                data-testid="about-photo"
                className="relative w-full aspect-[4/5] object-cover grayscale-[15%]"
              />
            </div>
          </div>

          {/* Copy */}
          <div className="md:col-span-7" data-testid="about-copy">
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#EFE9D4]">
              People over <span className="italic text-[#36C281]">transactions.</span>
            </h2>

            <div className="mt-8 space-y-5 text-lg text-neutral-300 leading-relaxed max-w-2xl">
              <p data-testid="about-para-1">
                I've spent the better part of a decade — 8 to 10 years — investing in
                Australian property through multiple market cycles, building a multi-million
                dollar personal portfolio along the way. That experience was sharpened working
                alongside some of the country's established national buyers agents, learning
                what genuinely separates a good purchase from a costly one.
              </p>
              <p data-testid="about-para-retire">
                In just over seven years of investing, I built that portfolio to the point where
                it replaced — and retired — my income. Now my mission is simple: to help others do
                the same, following the very same blueprint for success that worked for me.
              </p>
              <p data-testid="about-para-2">
                Somewhere along the way, the industry lost something. I started iScout Property
                to bring connection, clarity and integrity back to the relationship between
                a buyer and their agent — no spin, no pressure, just honest, transparent work
                done in your corner.
              </p>
              <p data-testid="about-para-3">
                Here in Cairns, that means something deeper. For local home buyers, I'm not
                chasing a quick flip or a yield figure on a spreadsheet. I'm helping you match a
                home to the life you'll live inside it — for 10, 20, even 30 years. That's a
                responsibility I don't take lightly.
              </p>
            </div>

            <div className="mt-10 flex flex-wrap gap-3" data-testid="about-pillars">
              {pillars.map((p) => (
                <span
                  key={p.label}
                  data-testid={`about-pillar-${p.label.toLowerCase()}`}
                  className="px-5 py-2 text-sm tracking-wide border border-neutral-700 text-neutral-200 rounded-full"
                >
                  {p.label}
                </span>
              ))}
            </div>

            <a
              href="#contact"
              data-testid="about-cta"
              className="btn-outline mt-10 inline-flex"
            >
              Have a real conversation <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
